import LoginUtil from 'mptcfe-login-util';
import Util from '@/utils/util';
// import { createAxiosByInterceptors } from './axios'
// import { getUisHost } from '@/config/urlConfig';

let userInfoPromise = null; // promise共享，解决登录信息状态共享问题
const loginUtil = new LoginUtil()
// const uisInstance = createAxiosByInterceptors({
//     baseURL: getUisHost(),
// })

// 获取用户信息
export const getUserInfo = async () => {
    const env = Util.getEnvironment()
    if(!userInfoPromise){
        userInfoPromise = new Promise((resolve, reject) => {
            loginUtil.checkLogin({
                env: env,
                successFun: (res) => {
                    resolve(res)
                },
                failureFun: (error) => {
                    reject(error)
                }
            })
        })
    }
    return userInfoPromise
}